import { mix, rgba } from 'polished';
import styled, { css } from 'styled-components';
import { supportFieldLineLayout } from '@clds/toolbar-layout';
import { typographyMixin } from '@clds/typography';
import { borderColorVariant, textFieldTheme } from '../theme.js';
export const FieldBase = styled.div `
  &&& {
    ${(props) => typographyMixin(props.size, 'regular')};
    align-items: center;
    background-color: ${textFieldTheme.background.color.base};
    border: ${textFieldTheme.border.width} solid ${borderColorVariant};
    border-radius: ${textFieldTheme.border.radius};
    overflow: hidden;
    ${supportFieldLineLayout()};
    color: ${textFieldTheme.color.base};
    display: flex;
    transition:
      border-color 250ms,
      box-shadow 250ms;

    ${({ isFocused }) => isFocused &&
    css `
        border-color: ${textFieldTheme.border.color.focus};
        box-shadow: 0 0 0 3px
          ${(props) => rgba(textFieldTheme.outline.color.base(props), 0.5)};
      `}

    ${({ isDisabled }) => isDisabled
    ? css `
            background-color: ${(props) => mix(0.5, props.theme.palette.surfaceAlt, props.theme.palette.contrastInvert)};
            border-color: ${(props) => mix(0.5, props.theme.palette.surfaceAlt, props.theme.palette.contrastInvert)};
            color: ${(props) => mix(0.5, props.theme.palette.surfaceAlt, props.theme.palette.contrastInvert)};
          `
    : css `
            &:hover {
              border-color: ${textFieldTheme.border.color.hover};
            }
          `}

  input {
      ${({ size }) => typographyMixin(size, 'regular')};
      background: none;
      border: none;

      color: ${textFieldTheme.input.color.base};
      height: 100%;
      width: 100%;

      ${(props) => css `
        padding: ${textFieldTheme.input.padding[props.size]};
      `};

      ${({ hasLeadingDecoration }) => hasLeadingDecoration &&
    css `
          padding-left: ${textFieldTheme.input.decorationMargin};
        `}

      ${({ hasTrailingDecoration }) => hasTrailingDecoration &&
    css `
          padding-right: ${textFieldTheme.input.decorationMargin};
        `}

    &:disabled,
    &::placeholder {
        color: ${textFieldTheme.input.color.placeholder};
      }

      &:focus {
        outline: none;
      }

      // hide (chrome) browser's auto-complete background
      box-shadow: 0 0 0 100px ${textFieldTheme.background.color.base} inset;

      /* bidirectional text handling,
         The directionality is calculated using the P2 and P3 rules of the Unicode Bidirectional Algorithm  */
      unicode-bidi: plaintext;
    }
  }
`;
